import { styled } from '@mui/system';

const FormikErrorMessage = styled('p')(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: '0.75rem',
  margin: '3px 14px 0px 14px',
}));

export default FormikErrorMessage;
